module.exports = __webpack_public_path__ + "static/media/home-bg1.b91a74f3.png";